import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";

export async function InsertAsistencia(objeto) {
  const {
    fecha,
    hora,
    procedimiento,
    tipo,
    tarifa,
    honorario,
    asignado,
    paciente,
    foto,
    idliquidacion = null,   // default a null si no viene
    paratarifa =  "SI",
    parahonorario = "SI"
  } = objeto;

  // Validar campos requeridos (idliquidacion no es requerido según tu indicación)
  if (!fecha || !hora || !procedimiento || !tipo || !tarifa || !honorario || !asignado || !paciente) {
    throw new Error("Todos los campos son obligatorios.");
  }

  const token = getAuthToken();
  const formData = new FormData();

  formData.append("fecha", fecha);
  formData.append("hora", hora);
  formData.append("procedimiento", procedimiento);
  formData.append("tipo", tipo);
  formData.append("tarifa", tarifa);
  formData.append("honorario", honorario);
  formData.append("asignado", asignado);
  formData.append("paciente", paciente);
  formData.append("paratarifa", paratarifa);
  formData.append("parahonorario", parahonorario);
  // Aseguramos siempre mandar idliquidacion (como null si no viene)
  // Nota: FormData convierte null a la cadena "null". Si tu backend prefiere vacío, cambia por (idliquidacion ?? "")
  formData.append("idliquidacion", idliquidacion === undefined ? null : idliquidacion);

  if (foto instanceof File) {
    const extension = foto.name.split(".").pop();
    const nuevoNombre = `${fecha} ${hora} ${paciente}.${extension}`;
    formData.append("Upload", foto, nuevoNombre);
    formData.append("foto", extension); // (Si realmente quieres guardar solo la extensión; si necesitas el nombre completo cambia a nuevoNombre)
  } else {
    // Si quieres explícitamente indicar que no hay foto:
    // formData.append("foto", "");
  }

  try {
    const response = await fetch(`${CALL_API}/InsertAsistencia`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
        // No agregues Content-Type; el navegador lo gestiona con FormData
      },
      body: formData
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al Ingresar la Asistencia");
    }

    return data.isCreated;
  } catch (error) {
    console.error("Error en InsertAsistencia:", error);
    throw error;
  }
}

export async function updateAsistencia(objeto) {
  const {
    idasistencia,
    fecha,
    hora,
    procedimiento,
    tipo,
    tarifa,
    honorario,
    asignado,
    paciente,
    foto,
    oldFoto,
    parahonorario = "SI",
    paratarifa = "SI"
  } = objeto;
  // Validar campos requeridos
  if (!idasistencia) {
    throw new Error("El ID es obligatorio.");
  }
  if (!fecha || !hora || !procedimiento || !tipo || !tarifa || !honorario || !asignado || !paciente) {
    throw new Error("Todos los campos son obligatorios.");
  }

  const token = getAuthToken();
  const formData = new FormData();
  formData.append('idasistencia', idasistencia);
  formData.append('fecha', fecha);
  formData.append('hora', hora);
  formData.append('procedimiento', procedimiento);
  formData.append('tipo', tipo);
  formData.append('tarifa', tarifa);
  formData.append('honorario', honorario);
  formData.append('asignado', asignado);
  formData.append('paciente', paciente);
  formData.append('parahonorario', parahonorario);
  formData.append('paratarifa', paratarifa);
  // Manejar la imagen
  if (foto instanceof File) {
    // Si se sube una nueva imagen, renombrarla con la cédula
    const extension = foto.name.split(".").pop();
    const nuevoNombre = `${idasistencia}.${extension}`;
    formData.append("Upload", foto, nuevoNombre);
    formData.append("foto", nuevoNombre); // Guardar el nombre del archivo
  } else {
    // Si no se sube una nueva imagen, usar la existente
    formData.append("foto", oldFoto);
  }
  try {
    const response = await fetch(`${CALL_API}/UpdateAsistencia/${idasistencia}`, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Error al actualizar la Asistencia");
    }
    return data.isSaved;
  } catch (error) {
    console.error("Error en updateAsistencia:", error);
    throw error;
  }
}

export async function getAllAsistencia() {
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/Asistencia`, {
      headers: { Authorization: "Bearer " + token },
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error("No se encontro informacion");
    }
    return data.asistencias;
  } catch (error) {
    console.error("Error en getAllAsistencia:", error);
    throw error;
  }
}

export async function deleteAsistencia(idasistencia) {
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/DeleteAsistencia/${idasistencia}`, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Error al eliminar la asistencia");
    }
    return data.isDeleted;
  } catch (error) {
    console.error("Error en deleteAsistencia:", error);
    throw error;
  }
}